import Vue from 'vue'

Vue.filter('newlineToBr', function (original) {
  if (original !== null) {
    original = original.replace(/\n/g, '<br />')
  }
  return original
})



// WEBPACK FOOTER //
// ./src/filters/newlineToBr.js